var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-breadcrumb',{attrs:{"id":"crumb-container","items":_vm.breadCrumbs()}})
}
var staticRenderFns = []

export { render, staticRenderFns }